"use client";

import React from "react";
import { motion } from "framer-motion";
import { HeroSearchCar } from "./HeroSearchCar";

export function IKTravelHero() {
  return (
    <section
      className="relative min-h-screen w-full min-w-0 max-w-full overflow-x-hidden"
      id="home"
      aria-labelledby="hero-heading"
    >
      <div className="container mx-auto px-4 sm:px-6 pt-3 sm:pt-4 md:pt-6 pb-8 sm:pb-12 min-w-0">
        <div className="max-w-7xl mx-auto min-w-0">
          <div className="text-center mb-4 sm:mb-6">
            {/* Top Branding Eyebrow Badge */}
            <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-[#FFB51D]/10 dark:bg-[#FFB51D]/20 border border-[#FFB51D]/30 mb-3 sm:mb-4">
              <span className="text-xs sm:text-sm font-bold text-[#131222] dark:text-neutral-100 tracking-wider uppercase">
                I K TOURS AND TRAVELS
              </span>
              <span className="text-[#FFB51D] text-xs font-bold" aria-hidden="true">✦</span>
              <span className="text-xs sm:text-sm font-semibold text-[#131222] dark:text-[#FFB51D]">
                Serving Since 1985
              </span>
            </div>

            {/* Main Tagline Heading */}
            <h1
              id="hero-heading"
              className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold mb-2 sm:mb-3 tracking-tight"
            >
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#FFB51D] via-[#FFA500] to-[#FF9500]">
                Legacy
              </span>{" "}
              <span className="text-[#131222] dark:text-white">
                In Every Mile
              </span>
            </h1>

            {/* Sub-tagline & Services */}
            <div className="max-w-2xl mx-auto mb-3 sm:mb-4 px-1 space-y-1">
              <p className="text-xs sm:text-sm md:text-base text-neutral-600 dark:text-neutral-300">
                Cars & Bikes • Self Drive • Chauffeur & Rider Services
              </p>
            </div>

            {/* Highlights Bar */}
            <div className="flex flex-wrap items-center justify-center gap-2 sm:gap-3 mb-4 sm:mb-6 text-xs sm:text-sm text-neutral-700 dark:text-neutral-300">
              <span className="font-semibold text-[#131222] dark:text-white">Since 1985</span>
              <span className="text-[#FFB51D]" aria-hidden="true">•</span>
              <span className="font-semibold text-[#131222] dark:text-white">Premium Fleet</span>
              <span className="text-[#FFB51D]" aria-hidden="true">•</span>
              <span className="font-semibold text-[#131222] dark:text-white">Transparent Pricing</span>
              <span className="text-[#FFB51D]" aria-hidden="true">•</span>
              <span className="font-semibold text-[#131222] dark:text-white">Easy Booking</span>
            </div>
          </div>

          <div className="w-full">
            <HeroSearchCar
              onSearch={(data) => {
                console.log("Search data:", data);
              }}
            />
          </div>

          <div className="mt-8 sm:mt-12 text-center">
            <p className="text-xs sm:text-sm text-neutral-600 dark:text-neutral-400 mb-4 text-center max-w-xl mx-auto px-2">
              ✓ No Hidden Charges • ✓ Unlimited Kilometers • ✓ Instant Booking
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
